<template>
  <div class="bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 p-5 flex items-start space-x-4 transition-transform hover:-translate-y-1 duration-200">
    <div class="p-3 rounded-lg flex-shrink-0" :class="bgColor">
        <Icon :name="iconName" class="w-6 h-6" :class="iconColor" />
    </div>
    <div>
        <h4 class="text-sm font-medium text-slate-500 dark:text-slate-400">{{ title }}</h4>
        <div class="mt-1 text-2xl font-bold text-slate-800 dark:text-white">{{ value }}</div>
        <div class="mt-1 text-xs text-slate-400">{{ subtext }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
    title: string
    value: string | number
    subtext: string
    iconName: string
    iconColor: string
    bgColor: string
}>()
</script>
